export const ROW_HEIGHT = 18;
export const ROW_INDENT = 16;
export const PREVIEW_DEPTH = 2;
export const PREVIEW_MAX_ARRAY_LENGTH = 100;
export const PREVIEW_MAX_STRING_LENGTH = 1000;
export const PREVIEW_MAX_SET_LENGTH = 5;
export const PREVIEW_MAX_MAP_LENGTH = 5;
export const PREVIEW_MAX_OBJECT_LENGTH = 5;
